"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.ConditionalMessageBar = void 0;

var _react = require("react"),
    _react2 = _interopRequireDefault(_react),
    _propTypes = require("prop-types"),
    _propTypes2 = _interopRequireDefault(_propTypes),
    _officeUiFabricReact = require("office-ui-fabric-react"),
    _ShowHide = require("../ShowHide"),
    _ShowHide2 = _interopRequireDefault(_ShowHide);

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

var ConditionalMessageBar = exports.ConditionalMessageBar = function (a) {
  var b = a.type,
      c = a.txt,
      d = a.show;
  return _react2.default.createElement(_ShowHide2.default, {
    show: d
  }, _react2.default.createElement(_officeUiFabricReact.MessageBar, {
    messageBarType: _officeUiFabricReact.MessageBarType[b]
  }, c));
};

ConditionalMessageBar.propTypes = {
  /**
  For a full list of enums, visit [MessageBarType](https://developer.microsoft.com/en-us/fluentui#/controls/web/messagebar#MessageBarType)
  */
  type: _propTypes2.default.oneOf(["error", "success"]),
  txt: _propTypes2.default.string,

  /**
  Show or hide the MessageBar
  */
  show: _propTypes2.default.bool
}, ConditionalMessageBar.defaultProps = {
  type: "error",
  txt: "",
  show: !1
}, exports.default = _react2.default.memo(ConditionalMessageBar);